/**
 * Utility functions for InboxList
 */

/** Truncate text to a specific length */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
}
